"use client";
import * as React from "react";
const SvgSentimentVeryDissatisfiedSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 9.2A4.4 4.4 0 0 0 3.91 12h8.18A4.4 4.4 0 0 0 8 9.2M4.66 8l.84-.85.85.85.85-.85-.85-.85.85-.84-.85-.85-.85.85-.84-.85-.85.85.85.84-.85.85zm3.33-8A8 8 0 0 0 0 8a8 8 0 1 0 16 0 8 8 0 0 0-8-8m0 14.4A6.4 6.4 0 0 1 1.6 8 6.4 6.4 0 1 1 8 14.4m3.34-9.8-.84.86-.85-.85-.85.85.85.84-.85.85.85.85.85-.85.84.85.85-.85-.85-.85.85-.84z" }));
export {
  SvgSentimentVeryDissatisfiedSharp as default
};
